// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__yWRMM","item":"PaymentsMobile_item__3swI3","label":"PaymentsMobile_label__N9HJQ","amount":"PaymentsMobile_amount__XYr8S"};